import React from 'react';
import PropTypes from 'prop-types';
import { Box, Modal, IconButton } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { detectLanguageFromPathname, translate } from '../../../i18n';

function CameraModal({ open, onClose, isMobile }) {
  const location = useLocation();
  const language = detectLanguageFromPathname(location.pathname);
  const t = (key, params) => translate(language, key, params);
  const cameraImageSrc = language === 'en'
    ? '/assets/camera_places_en.png'
    : '/assets/camera_places.png';
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="camera-image-modal"
      aria-describedby="camera-places-image"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          maxWidth: isMobile ? '95vw' : '80vw',
          maxHeight: isMobile ? '90vh' : '85vh',
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          overflow: 'hidden',
          outline: 'none',
        }}
      >
        {/* 閉じるボタン */}
        <IconButton
          onClick={onClose}
          aria-label={t('header.closeModal')}
          sx={{
            position: 'absolute',
            top: 12,
            right: 12,
            width: '32px',
            height: '32px',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            color: 'white',
            zIndex: 1,
            fontSize: '18px',
            fontWeight: 'bold',
            borderRadius: '50%',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              transform: 'scale(1.1)',
            },
            transition: 'all 0.2s ease',
          }}
        >
          ✕
        </IconButton>
        
        {/* カメラ画像 */}
        <Box
          component="img"
          src={cameraImageSrc}
          alt={t('header.cameraImageAlt')}
          sx={{
            width: '100%',
            height: 'auto',
            maxHeight: isMobile ? '85vh' : '75vh',
            display: 'block',
            objectFit: 'contain',
          }}
        />
      </Box>
    </Modal>
  );
}

CameraModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default CameraModal;
